import { gql } from "@apollo/client";

const CLOSEDCHATCOUNTSUBSCRIPTION = gql`
  subscription closedchatcountchanged {
    closedchatcountchanged {
      success
      error
      result
    }
  }
`;
export default CLOSEDCHATCOUNTSUBSCRIPTION;
